import {alpha} from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                sizeLarge: {
                    height: 48,
                },
                containedInherit: {
                    borderRadius: 12,
                    color: theme.palette.grey[800],
                    boxShadow: theme.customShadows.z8,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[400],
                    },
                },
                containedPrimary: {
                    borderRadius: 12,
                    boxShadow: theme.customShadows.primary,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.darker,
                    }
                },
                containedSecondary: {
                    boxShadow: theme.customShadows.secondary,
                },
                outlinedInherit: {
                    border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
                textInherit: {

                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,

                    },
                },
                textWhite: {
                    color: theme.palette.grey['0'],
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                        color: theme.palette.grey['600'],
                    },
                },
            },
        },
    };
}
